import { toRefs, reactive } from 'vue';
import Api from '../api/Account';

const initialState = {
    contracts:            [],
    contractId:          null,
    isCompanyAccount:     false,
    sales:                [],
    accountSummary:       {},
    accountSummaryHeader: '',
    loading:              true,
    sending:              false,
    sent:                 false,
    sendingError:         '',
    sendingSuccess:       '',
    officeName:           '',
    emails:               [],
    email:                null,
    vippsEnabled:         false,
    isTABS:               true,
};

const state = reactive({ ...initialState });

export default {
    state: toRefs(state),
    init (contractId) {
        console.log(contractId)
        state.loading = true;
        Api.Get(contractId).then(function (res) {
            state.contractId = contractId;
            state.loading = false;
            if (res.success) {
                state.sales = res.sales;
                state.accountSummary = res.accountSummary.maximized[0];
                state.accountSummaryHeader = res.accountSummary.header;
                state.vippsEnabled = res.vipps_enabled;
                state.officeName = res.session.office_name;
                state.isTABS = res.isTABS;
                if (res.emails.length) {
                    state.emails = res.emails;
                    state.email = res.emails[0];
                }
            }
        })
    },
    initCompanyAccount() {
        state.isCompanyAccount = true;
        Api.GetContracts().then(function (res) {
            state.loading = false;
            if (res.success) {
                state.contracts = res.contracts;
            }
        })
    },
    sendSummary () {
        if (this.isSending()) {
            return;
        }
        state.sendingSuccess = '';
        state.sendingError = '';

        if (state.email === null || state.email.length === 0) {
            state.sendingError = $t('Mangler gyldig epost. Klarte ikke sende');
            return;
        }
        state.sending = true;
        Api.Send(state.email).then(res => {
            state.sending = false;
            state.sent = res.success;
            if (res.success) {
                state.sendingSuccess = res.message
            } else {
                state.sendingError = res.message
            }
        }).catch(e => {
            state.sendingError = $t('Det skjedde noe galt ved utsendelsen. Prøv igjen senere');
            state.sending = false;
        })
    },
    isTABS() {
        return state.isTABS;
    },
    isSending () {
        return state.sending;
    },
    isSent () {
        return state.sent;
    },
    isLoading () {
        return state.loading
    },
    isVippsEnabled () {
        return state.vippsEnabled
    },
    getSales () {
        return state.sales;
    },
    getSale (id) {
        return state.sales.find(sale => {
            return sale.sale_id === id;
        })
    },
    setEmail(email) {
        state.email = email;
    },
    getEmails () {
        return state.emails;
    },
    getSendingErrorMessage () {
        return state.sendingError;
    },
    getSendingSuccessMessage () {
        return state.sendingSuccess;
    },
    getAccountSummary () {
        return state.accountSummary;
    },
    getContracts() {
        return state.contracts;
    },
    fetchDetailedContractInfo(contractId) {
        this.init(contractId);
    },
    getContractId() {
        return state.contractId;
    },
    isCompanyAccount() {
        return state.isCompanyAccount;
    }
}
